export const locale = {
  lang: 'fr',
  data: {
    DASHBOARD: "Tableau De Bord",
    GAINS: "Mes Gains",
    RESULTS: "Mes Résultats",
    TABLE: {
      SEARCH: "Chercher",
      SHOW: "Afficher",
      ENTRIES: "entrées",
      DATE: "Date",
      MISSION: "Mission",
      SHOP: "Point de vente",
      DISTANCE: "Distance (km)",
      CITY: "Ville",
      STATUS: "Statut",
      VALIDATION_DATE: "Date de validation",
      REFUND: "Remboursement",
      GIFT_VOUCHER: "Chèque cadeau",
      SALARY: "Salaire",
    },
    HOME: {
      DAYS_AGO: "jours",
      DAYS: "jours",
      IN: "Dans",
      GO_TO_QUESTIONNAIRE: "Aller au questionnaire",
      PENDING_ACTIONS: "Action(s) en attente(s)",
      YOU_CAN_SUBMIT_THE_QUESTIONNAIRE: "Vous pouvez soumettre le questionnaire",
      PROOF_OF_PASSAGE: "Preuve de passage",
      SUBMIT_QUESTIONNAIRE: "Soumettre le questionnaire",
      VIEW_THE_BRIEFING: "Consulter le briefing",
      ALL_IS_WELL: "Tout va bien",
      IN_PROGRESS: "En cours",
      TEXT_IN_PROGRESS: "Mince, il semble que vous n'ayez aucune mission en cours !",
      TO_DO: "A faire",
      TEXT_TO_DO: "Mince, il semble que vous n'ayez rien à faire ! Positionnez-vous sur une mission !",
      PROPOSED_MISSIONS: "Missions Proposées",
      TYPE_OF_REWARD: "Type de récompense",
      SALARY: "Salaire",
      REFUND: "Remboursement",
      GIFT_VOUCHER: "Chèque cadeau",
      DISTANCE: "Distance",
      CLEAR_ALL_FILTERS: "Retirer tous les Filtres",
      SCENARIO: "Scénario",
      INTERNET_VISIT: "Visite Internet",
      DESCRIPTION: "Description",
      NUMBER_OF_QUESTIONS: "Nombre de questions",
      DATES: "Dates",
      DU: "Du",
      TO: "au",
      TIME_OF_DAY: "Moment de la journée",
      ADDRESS: "Adresse",
      POINT_OF_SALE_OF_YOUR_CHOICE: "Point de vente de votre choix",
      COMPENSATION: "Dédommagement",
      SEE_THE_BRIEFING_FOR_MORE_INFORMATION: "Consulter le briefing pour en savoir plus...",
      VISIT_DATES: "Dates de visite",
      DAYS_AVAILABLE_FOR_THE_MISSION: "Jours disponibles pour la mission",
      SELECT_ALL_THE_DATES_THAT_SUIT_YOU: "Sélectionnez toutes les dates qui vous conviennent",
      OUR_TEAMS_WILL_ALLOCATE_YOU_ACCORDING_TO_THE_OTHER_ASSIGNMENTS_YOU_HAVE_APPLIED_FOR: "Nos équipes se chargent de vous répartir en fonction des autres missions où vous avez postulé",
      POSITION_YOURSELF: "Se positionner",
    },
    ATTENTION: "ATTENTION",
    CLAIM: "Réclamer",
    POPOVER_REFUND_P1: "Ils sont effectués automatiquement sur votre compte bancaire par virement, au maximum 45 jours après chaque mission. Le remboursement peut-être plus rapide pour certaines missions dont le montant est élevé.",
    POPOVER_REFUND_P2: "vous devez renseigner votre IBAN dans votre compte sinon nous ne pourrons pas procéder à vos remboursements.",
    POPOVER_COMPENSATION_P1: "A chaque fois que vous réalisez une mission dédommagée par chèque cadeau, celui-ci se cumule à ceux que vous avez déjà cumulés lors de précédentes missions.",
    POPOVER_COMPENSATION_P2: 'pour recevoir vos chèques cadeaux vous devez en faire la demande en cliquant sur le bouton "réclamer".',
    POPOVER_SALARY_P1: "Vous percevrez un salaire pour l'ensemble des missions réalisées avec contrat en CDD d'usage. Le montant de votre salaire sera automatiquement viré sur votre compte bancaire entre le 10 et le 15 du mois suivant si elles sont réalisées avant le 25 du mois. Sinon elles passent sur le mois suivant.",
    POPOVER_SALARY_P2: "vous devez renseigner votre IBAN dans votre compte sinon nous ne pourrons pas procéder aux virements de vos salaires.",
    REFUNDS: "Remboursements",
    ACTION_REMEDIATION: "Actions de remédiation",
    DISPLAY_ALL: "Afficher tout",
    COST: "Coût",
    PRIORITY: "Importance",
    TITLE: "Titre",
    CYBERSCORE: "Cyber Score",
    NO_CONFORMITY: "Non-conformités",
    PROCEDURE: "Procédure",
    LOGICIEL: "Logiciels",
    MATERIEL: "Matériel",
    REMEDIAL: {
      TITLE: "Actions de remédiation",
      CONTENT: "Le plan de remédiation comporte un certain nombre d’actions en réponse aux écarts relevés, les actions présentés sont catégorisé par niveau de difficulté de mise en oeuvre et par coût. L’objectif étant de pouvoir prendre en charge une partie ou la totalité des actions.",
      CONTENT_NEXT: "Séléctionné les actions que vous souhaitez prendre en charge afin de les déplacer dans la section suivi des actions."
    },
    ACTION_PLAN: {
      LABELS: {
        DIFFICULTY: {
          EASY: "Facile",
          MEDIUM: "Moyenne",
          HARD: "Difficile"
        },
        PRICE: {
          ONE: "€",
          TWO: "€€",
          THREE: "€€€"
        },
        IMPORTANCE: {
          EASY: "Faible",
          MEDIUM: "Modérée",
          HIGH: "Élevée"
        }
      },
      OBJECTIF: {
        TITLE: "Actions de remédiation"
      }
    },

  }
}
